// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsSessionDetailsCondition } from './InternalendpointsSessionDetailsCondition';
import {
  InternalendpointsSessionDetailsConditionFromJSON,
  InternalendpointsSessionDetailsConditionFromJSONTyped,
  InternalendpointsSessionDetailsConditionToJSON,
  InternalendpointsSessionDetailsConditionToJSONTyped,
} from './InternalendpointsSessionDetailsCondition';

/**
 *
 * @export
 * @interface InternalendpointsSessionDetailsStatus
 */
export interface InternalendpointsSessionDetailsStatus {
  /**
   *
   * @type {Array<InternalendpointsSessionDetailsCondition>}
   * @memberof InternalendpointsSessionDetailsStatus
   */
  conditions?: Array<InternalendpointsSessionDetailsCondition>;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsStatus
   */
  expiryTime?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsStatus
   */
  failureReason?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsStatus
   */
  lastActivity?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsStatus
   */
  state?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsStatus
   */
  terminationReason?: string;
}

/**
 * Check if a given object implements the InternalendpointsSessionDetailsStatus interface.
 */
export function instanceOfInternalendpointsSessionDetailsStatus(
  value: object,
): value is InternalendpointsSessionDetailsStatus {
  return true;
}

export function InternalendpointsSessionDetailsStatusFromJSON(
  json: any,
): InternalendpointsSessionDetailsStatus {
  return InternalendpointsSessionDetailsStatusFromJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsSessionDetailsStatus {
  if (json == null) {
    return json;
  }
  return {
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(
            InternalendpointsSessionDetailsConditionFromJSON,
          ),
    expiryTime: json['expiry_time'] == null ? undefined : json['expiry_time'],
    failureReason:
      json['failure_reason'] == null ? undefined : json['failure_reason'],
    lastActivity:
      json['last_activity'] == null ? undefined : json['last_activity'],
    state: json['state'] == null ? undefined : json['state'],
    terminationReason:
      json['termination_reason'] == null
        ? undefined
        : json['termination_reason'],
  };
}

export function InternalendpointsSessionDetailsStatusToJSON(
  json: any,
): InternalendpointsSessionDetailsStatus {
  return InternalendpointsSessionDetailsStatusToJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsStatusToJSONTyped(
  value?: InternalendpointsSessionDetailsStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(
            InternalendpointsSessionDetailsConditionToJSON,
          ),
    expiry_time: value['expiryTime'],
    failure_reason: value['failureReason'],
    last_activity: value['lastActivity'],
    state: value['state'],
    termination_reason: value['terminationReason'],
  };
}
